import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { make } from 'vuex-pathify'

const state = {
  all: [],
  single: null,
  publishers: [],
  types: [],
  users: [],
  metaDataColumns: null,
  publisherId: null,
  savedNewProduct: null,
  metaDataFields: null,
  subjectCategories: null
}

export default {
  namespaced: true,
  state,
  actions: {
    ...make.actions(state),
    ...actions
  },
  getters: {
    ...make.getters(state),
    ...getters
  },
  mutations: {
    ...make.mutations(state),
    ...mutations
  }
}
